import Web3 from "web3";
import { LIONTRAVELERS_CONTRACT_ADDRESS } from "../contractAddress";
import lionTravelerAbi from "../Abi/travelerAbi.json";

export const web3LionTravelerInstance = () => {
  const web3 = new Web3(window.ethereum)
  const contract = new web3.eth.Contract(lionTravelerAbi, LIONTRAVELERS_CONTRACT_ADDRESS);
  return contract;
}
